import { z } from '@/utils/zod'

export const OrganizationDomainSchema = z.object({
    type: z.enum(['email']),
    domain: z.string().min(1),
    dnsRecords: z.array(z.record(z.string(), z.any())),
    verified: z.boolean(),
    registeredAt: z.isoDateOnly,
    sendingAddress: z.email().or(z.literal('')).nullable(),
})

export type OrganizationDomain = z.infer<typeof OrganizationDomainSchema>
